module.exports = __webpack_public_path__ + "img/shiba.f8adaf66.jpeg";